import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {VwuiAngularModule, VwuiModalConfig, VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {TranslatePipe} from '@ngx-translate/core';

export interface SubmitProjectIntakeModalData {
    projectName: string;
}

@Component({
    selector: 'app-submit-project-intake-modal',
    templateUrl: './submit-project-intake-modal.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, VwuiAngularModule]
})
export class SubmitProjectIntakeModalComponent {
    public readonly modalRef = inject(VwuiModalRef);
    public readonly projectName = inject<VwuiModalConfig<SubmitProjectIntakeModalData>>(VwuiModalConfig).data.projectName;
}
